/* Wubs motion – scroll-reveal via IntersectionObserver.
   Döljningen sker i CSS (.wubs-motion, satt inline i <head>). Här läggs .is-inview
   när elementet skrollas in. Ovan-fold-element avslöjas direkt vid load (inladdningskänsla). */
(function () {
  const root = document.documentElement;
  const SEL = [
    '.wubs-section__head',
    '.wubs-prods__grid > *', '.wubs-cats__grid > *', '.wubs-conf__grid > *',
    '.wubs-duo__grid > *', '.wubs-guides__grid > *', '.wubs-revs__grid > *',
    '.wubs-collection__prodgrid > *', '.wubs-pdp-related__grid > *',
    '.wubs-faq__list > *', '.wubs-help__list > *',
    '.wubs-hero__field-body', '.wubs-hero__panel', '[data-wubs-reveal]',
    // Startsidan (wth-*): BEHÅLLAREN observeras, barnen avslöjas via CSS (animation per sektion)
    '.wth-renovate-head', '.wth-configs-head', '.wth-guides2-head', '.wth-reviews-head', '.wth-trust-head', '.wpb-head',
    '.wth-hero-layout', '.wth-brand-layout', '.wth-provbit-layout', '.wth-icon-row',
    '.wth-renovate-grid', '.wth-morecat-row', '.wth-trust2-grid', '.wth-configs-grid',
    '.wth-guides2-collage', '.wth-review-track', '.wth-benefit-grid', '.wth-system-grid', '.wth-trust-grid'
  ].join(',');
  // OBS: cut-outsen observeras INTE (de startar på scale(0) = noll yta → observern ser dem aldrig).
  // De reveal:as via förälderns .is-inview i CSS (.wth-hero-layout/.wth-brand-layout/.wth-configs-grid).

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    root.classList.remove('wubs-motion'); // allt synligt, ingen rörelse
    return;
  }

  // Stagger inom rutnät: varje barn får en liten fördröjning (tak vid 8 för att undvika sega svansar)
  const GRIDS = '.wubs-prods__grid,.wubs-cats__grid,.wubs-conf__grid,.wubs-duo__grid,' +
    '.wubs-guides__grid,.wubs-revs__grid,.wubs-collection__prodgrid,.wubs-pdp-related__grid,' +
    '.wubs-faq__list,.wubs-help__list,' +
    '.wth-hero-layout,.wth-brand-layout,.wth-provbit-layout,.wth-icon-row,' +
    '.wth-renovate-grid,.wth-morecat-row,.wth-trust2-grid,.wth-configs-grid,' +
    '.wth-guides2-collage,.wth-review-track,.wth-benefit-grid,.wth-system-grid,.wth-trust-grid';

  // Räknar upp trust-siffrorna (0 → målvärde) när sektionen skrollas in. Bevarar decimaler
  // och accent-suffixet (/5, %, +) som ligger i ett eget span. Körs en gång per rutnät.
  function countUp(grid) {
    var RANGE = 0.2;   // räkna bara upp de SISTA 20 % → börjar nära målet, inte på 0
    var dur = 1200;
    grid.querySelectorAll('.wth-trust2-value').forEach(function (val) {
      var node = val.firstChild; // sifferdelen = textnoden före accent-spanet
      if (!node || node.nodeType !== 3) return;
      var raw = node.textContent.trim();
      var m = raw.match(/^(\d+(?:[.,]\d+)?)/);
      if (!m) return;
      var comma = m[1].indexOf(',') > -1;
      var target = parseFloat(m[1].replace(',', '.'));
      var decimals = (m[1].split(/[.,]/)[1] || '').length;
      var finalStr = comma ? m[1].replace('.', ',') : m[1];
      var fmt = function (n) { var s = n.toFixed(decimals); return comma ? s.replace('.', ',') : s; };
      var startVal = target * (1 - RANGE); // börja på de sista siffrorna
      var startT = null, done = false;
      function set(str) { node.textContent = str; }
      function frame(t) {
        if (done) return;
        if (startT === null) startT = t;
        var p = Math.min((t - startT) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 5); // easeOutQuint → långsammare och långsammare in i mål
        set(fmt(startVal + (target - startVal) * eased));
        if (p < 1) requestAnimationFrame(frame); else { done = true; set(finalStr); }
      }
      set(fmt(startVal));
      requestAnimationFrame(frame);
      // Säkerhet: landa alltid på exakt slutvärde även om rAF stryps (t.ex. förhandsvisningen)
      setTimeout(function () { if (!done) { done = true; set(finalStr); } }, dur + 500);
    });
  }

  let fired = false;
  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        fired = true;
        e.target.classList.add('is-inview');
        if (e.target.classList.contains('wth-trust2-grid')) countUp(e.target);
        obs.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  function stagger(rot) {
    (rot || document).querySelectorAll(GRIDS).forEach((g) => {
      Array.prototype.forEach.call(g.children, (c, i) => {
        c.style.transitionDelay = (Math.min(i, 8) * 60) + 'ms';
      });
    });
  }

  function observera(rot) {
    (rot || document).querySelectorAll(SEL).forEach((el) => {
      if (!el.classList.contains('is-inview')) io.observe(el);
    });
  }

  stagger();
  observera();

  /* ⚠️⚠️ INNEHÅLL SOM INJICERAS EFTER SIDLADDNING MÅSTE ANMÄLAS HIT.
   * Döljningen görs i CSS (`.wubs-motion .wubs-prods__grid > * { opacity: 0 }`) och lyfts först
   * när observern sett elementet. Ett kort som läggs in av JS efteråt observeras aldrig och blir
   * därför OSYNLIGT FÖR ALLTID – det ser ut som att sektionen är tom fast markupen finns.
   * Failsafen nedan räddar det INTE: den kräver att observern aldrig gett utslag NÅGONSTANS på
   * sidan, och på en normal sida har den det.
   * Så här: `window.WubsMotion.scan(container)` efter att du injicerat.
   * `visa()` är nödutgången – den avslöjar direkt utan animation. */
  window.WubsMotion = {
    scan: function (rot) { stagger(rot); observera(rot); },
    visa: function (rot) {
      (rot || document).querySelectorAll(SEL).forEach((el) => el.classList.add('is-inview'));
    }
  };

  // Failsafe: om observern aldrig gav utslag (t.ex. bruten miljö) – avslöja allt, dölj aldrig innehåll
  window.addEventListener('load', () => setTimeout(() => {
    if (!fired) document.querySelectorAll(SEL).forEach((el) => el.classList.add('is-inview'));
  }, 3000));
})();
